export default {
  operationPromotion: {
    getPromoCode: ['get', '/promo_codes/'],
  },
};
